<template>
  <main>
    <mdb-container>
      <h1 class="sr-only">{{ $t('members.heading') }}</h1>
      <content-status
        v-if="!hasMembers"
        :empty-message="$t('members.empty')"
        :error-message="$t('members.load_error')"
        :failed="members.error"
        :loading="isLoading"
        :loading-label="$t('site.loading')"
        @retry="load"
      />

      <template v-else>
        <section v-if="active.length" class="pentagon-members-section" data-section="active">
          <section-divider :title="$t('members.active')" variant="crimson"/>
          <Jaar v-for="year in active" :key="year.year" :year="year" variant="active"/>
        </section>

        <section v-if="alumni.length" class="pentagon-members-section" data-section="alumni">
          <section-divider :title="$t('members.alumni')" variant="forest"/>
          <Jaar v-for="year in alumni" :key="year.year" :year="year" variant="alumni"/>
        </section>
      </template>
    </mdb-container>
  </main>
</template>

<script>
import { mdbContainer } from 'mdbvue';
import { mapState } from 'vuex';
import ContentStatus from '../components/ContentStatus.vue';
import Jaar from '../components/Jaar.vue';
import SectionDivider from '../components/SectionDivider.vue';

export default {
  name: 'Leden',
  components: {
    mdbContainer,
    ContentStatus,
    Jaar,
    SectionDivider,
  },
  computed: {
    ...mapState('intro', ['members']),
    active() {
      return this.members.data ? this.members.data.active : [];
    },
    alumni() {
      return this.members.data ? this.members.data.alumni : [];
    },
    hasMembers() {
      return this.active.length > 0 || this.alumni.length > 0;
    },
    // The request starts in created(), so "no data and no error" can only mean it is on its way.
    isLoading() {
      return !this.members.data && !this.members.error;
    },
  },
  created() {
    this.$store.commit('TOGGLE_OFF_NAVBAR_TRANSPARENT');
    this.load();
  },
  methods: {
    load() {
      this.$store.dispatch('intro/fetchMembers');
    },
  },
};
</script>

<style>
  .pentagon-members-section {
    padding-bottom: 1rem;
  }
</style>
